export const footerInfo =  {
    argentina:[
        {
            ciudad:"Buenos Aires",
            direccion:"Av Madero 942 13° piso – CP 1106.",
            tel:"+5411 7078 1034",
            email:"comip@comip.org.ar"
        },
        {
            ciudad:"Posadas",
            direccion:"Av. Lavalle 3236 – CP 3300. ",
            tel:"+54376 4428179/4427243",
            email:"posadas@comip.org.ar"
        },
    ],
    paraguay:[
        {
            ciudad:"Asunción",
            direccion:"Ayolas Nº895, esq. Piribebuy.",
            tel:"+59521 494088/494089",
            email:"comip@comip.org.py"
        },
        {
            ciudad:"Encarnación",
            direccion:"Av Moisés Bertoni y Tte. Castelli",
            tel:"+59521 7270236",
            email:"comip@comip.org.py"
        },
        
    ],
    info:"La  COMIP está integrada por los delegados del Paraguay y la Argentina, con el objetivo de gestionar las posibilidades técnicas y económicas del aprovechamiento de los recursos del río Paraná, y la sustentabilidad y preservación de los mismos. "
}